import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import InfoIcon from "../MultiToneIcons/InfoIcon";
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InfoIcon, _extends({
    cursor: "pointer",
    tabIndex: "0",
    as: "button",
    role: "button",
    ref: ref
  }, props));
});